import { render, staticRenderFns } from "./TabActivityHistory.vue?vue&type=template&id=38db003c"
import script from "./TabActivityHistory.vue?vue&type=script&lang=js"
export * from "./TabActivityHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports